// extracted by mini-css-extract-plugin
export default {"productSquareItem":"ProductSquareItem_productSquareItem__OGWS1","horizontal":"ProductSquareItem_horizontal__nUfJl"};